import React, { useEffect, useState } from 'react';
import M from 'materialize-css';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useParams } from 'react-router-dom';
import { useFirestore } from 'react-redux-firebase';
import { signUpStatus } from '../../constants/constants';
import { getCountryAndProvince } from '../../utils/CountryUtil';

function Profile() {
  let { id } = useParams();
  const firestore = useFirestore();
  const [profile, setProfile] = useState(null);
  const [useCache, setUseCache] = useState(false);

  useEffect(() => M.AutoInit(), []);

  useEffect(() => loadProfile(firestore, id), [firestore, id]);

  const loadProfile = (firestore, id) => {
    firestore
      .collection('profiles')
      .doc(id)
      .get()
      .then((doc) => {
        const profile = { id: doc.id, ...doc.data() };
        setProfile(profile);
        setUseCache(profile.useCache ? profile.useCache : false);
      });
  };

  const updateUseCache = (value) => {
    firestore
      .collection('profiles')
      .doc(profile.id)
      .update({
        useCache: value,
      })
      .then(() => {
        setUseCache(value);
      });
  };

  console.log(profile);
  const renderProfile = () => {
    console.log('useCache', useCache);
    const [countryName, provinceName] = getCountryAndProvince(profile.countryCode, profile.stateCode);
    const isOnWaitingList = profile.signUpStatus ? profile.signUpStatus === signUpStatus.ON_WAITING_LIST : false;
    return (
      <div>
        <p>Sign up Status: {profile.signUpStatus && isOnWaitingList ? 'Wait List' : 'Signed Up'}</p>
        <p>Platform: {profile.platform && profile.platform}</p>
        <p>Country: {countryName && countryName}</p>
        <p>State/Province: {provinceName && provinceName}</p>
        <p>Timezone: {profile.timezone}</p>
        <p>Email: {profile.email}</p>
        <p>User Name: {profile.userName}</p>
        <p>Name: {profile.name}</p>
        <p>Last Name: {profile.lastName}</p>
        <p>Gender: {profile.gender}</p>
        <p>Level: {profile.level}</p>
        <div className="switch">
          <label>Use Cache</label>
          <label>
            <input type="checkbox" checked={useCache} onChange={(e) => updateUseCache(e.target.checked)} />
            <span className="lever" />
          </label>
        </div>
      </div>
    );
  };

  return (
    <div className="container">
      <h4>Profile</h4>
      {profile ? renderProfile() : <div />}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    profiles: state.firestore.ordered.profiles,
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps))(Profile);
